module.exports = __webpack_public_path__ + "static/media/buildingConstruction19.9cbe0ec6.jpg";